import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function VehiculeForm() {
  const API_BASE = "https://srv968119.hstgr.cloud";
  const navigate = useNavigate();
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [pendingSubmissions, setPendingSubmissions] = useState([]);
  const [toast, setToast] = useState({ show: false, message: "", type: "info" });

  // Fonction pour afficher un toast
  const showToast = (message, type = "info") => {
    setToast({ show: true, message, type });
    setTimeout(() => {
      setToast({ show: false, message: "", type: "info" });
    }, 4000);
  };

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      syncPendingSubmissions();
    };
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    const storedSubmissions = localStorage.getItem("pendingVehiculeSubmissions");
    if (storedSubmissions) {
      setPendingSubmissions(JSON.parse(storedSubmissions));
    }

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const [vehicule, setVehicule] = useState({
    code_station: "NY-2",
    date_creation: getCurrentDate(),
    tv12: "34",
    franchise: "",
    couleur: "",
    chassis: "",
    nom: "",
    prenom: "",
    numero_serie_plaque: "",
    telephone: "",
    usage: "",
  });

  const handleChange = (e) => {
    let value = e.target.value;

    // Validation pour la franchise (format AA-1111-XX où XX = code région Niger)
    if (e.target.name === 'franchise') {
      value = value.toUpperCase();
      // Permettre seulement les lettres et chiffres avec des tirets
      value = value.replace(/[^A-Z0-9-]/g, '');
    }

    // Validation pour le téléphone (8 chiffres exactement)
    if (e.target.name === 'telephone') {
      value = value.replace(/\D/g, ''); // Supprimer tout sauf les chiffres
      if (value.length > 8) {
        value = value.substring(0, 8);
      }
    }

    setVehicule({ ...vehicule, [e.target.name]: value });
  };

  const validateForm = () => {
    // Validation de la franchise - doit se terminer par -XX (code région Niger valide)
    const franchisePattern = /^[A-Z]{2,3}-\d{4,6}-[A-Z]{2}$/;
    // if (!franchisePattern.test(vehicule.franchise)) {
    //   alert("La franchise doit être au format AA-1111-XX ou AAA-111111-XX où XX = code région Niger valide");
    //   return false;
    // }

    // Vérifier que le code de région est dans la liste autorisée
    const regionCode = vehicule.franchise.split('-').pop();
    const validRegionCodes = ['NY', 'TA', 'DO', 'TI', 'AZ', 'MA', 'ZR', 'DI'];
    // if (!validRegionCodes.includes(regionCode)) {
    //   alert(`Code de région invalide: ${regionCode}. Codes autorisés: ${validRegionCodes.join(', ')}`);
    //   return false;
    // }

    // Validation du téléphone
    if (vehicule.telephone.length !== 8) {
      showToast("Le numéro de téléphone doit contenir exactement 8 chiffres", "error");
      return false;
    }

    return true;
  };

  const addVehicule = async (data) => {
    const token = localStorage.getItem("token");
    const id_user = localStorage.getItem("id_user");
    const vehiculeData = { ...data, id_enregistreur: Number(id_user) };
    const res = await fetch(`${API_BASE}/vehicules`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify(vehiculeData),
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    } else {
      const responseData = await res.json();
      console.log("Ajout réussi :", responseData);
      navigate("qrcd/" + responseData.id_vehicule);
    }
  };

  const addVehiculeOffline = async (data) => {
    const token = localStorage.getItem("token");
    const id_user = localStorage.getItem("id_user");
    const vehiculeData = { ...data, id_enregistreur: Number(id_user) };
    const res = await fetch(`${API_BASE}/vehicules`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify(vehiculeData),
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    } else {
      const responseData = await res.json();
      console.log("Ajout réussi :", responseData);
      navigate("qrcd/" + responseData.id_vehicule);
    }
  };

  const syncPendingSubmissions = async () => {
    const submissions = JSON.parse(localStorage.getItem("pendingVehiculeSubmissions") || "[]");
    if (submissions.length === 0) return;

    const successfulSubmissions = [];
    const failedSubmissions = [];

    for (const submission of submissions) {
      try {
        await addVehiculeOffline(submission);
        successfulSubmissions.push(submission);
      } catch (error) {
        failedSubmissions.push(submission);
      }
    }

    localStorage.setItem("pendingVehiculeSubmissions", JSON.stringify(failedSubmissions));
    setPendingSubmissions(failedSubmissions);

    if (successfulSubmissions.length > 0) {
      const modal = document.getElementById("syncModal");
      if (modal) {
        document.getElementById("syncCount").textContent = successfulSubmissions.length;
        modal.showModal();
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      if (isOnline) {
        await addVehicule(vehicule);
      } else {
        const submissions = JSON.parse(localStorage.getItem("pendingVehiculeSubmissions") || "[]");
        const newSubmissions = [...submissions, vehicule];
        localStorage.setItem("pendingVehiculeSubmissions", JSON.stringify(newSubmissions));
        setPendingSubmissions(newSubmissions);

        navigate("qrcdoffline", { state: { vehicule } });
      }

      //onAdd();
      document.getElementById("my_modal_5").close();
      setVehicule({
        franchise: "",
        couleur: "",
        chassis: "",
        nom: "",
        prenom: "",
        numero_serie_plaque: "",
        telephone: "",
        usage: "",
      });
    } catch (error) {
      console.error("Erreur lors de l'ajout :", error);
    }
  };

  return (
    <div className="w-[80%] h-[70%] flex flex-col items-center absolute mt-[10%] ml-[10%] p-9 text-black dark:text-white">
      <div className="flex flex-row justify-between items-center w-full">
        <h2 className="text-xl font-bold">AJOUTER UN VÉHICULE</h2>
        <div className="flex items-center gap-2">
          {!isOnline && (
            <span className="text-red-500 font-bold">
              HORS LIGNE - {pendingSubmissions.length} EN ATTENTE
            </span>
          )}
          <button
            className="btn btn-success text-white"
            onClick={() => document.getElementById("my_modal_5").showModal()}
          >
            + NOUVEAU
          </button>
        </div>
      </div>

      {/* Tableau des enregistrements en attente */}
      {!isOnline && pendingSubmissions.length > 0 && (
        <div className="mt-6 w-full overflow-auto">
          <h3 className="text-lg font-semibold mb-2">ENREGISTREMENTS EN ATTENTE</h3>
          <table className="table table-zebra w-full">
            <thead>
              <tr>
                <th>NOM</th>
                <th>FRANCHISE</th>
                <th>TÉLÉPHONE</th>
                <th>USAGE</th>
              </tr>
            </thead>
            <tbody>
              {pendingSubmissions.map((v, index) => (
                <tr key={index}>
                  <td>{v.nom?.toUpperCase()}</td>
                  <td>{v.franchise?.toUpperCase()}</td>
                  <td>{v.telephone?.toUpperCase()}</td>
                  <td>{v.usage?.toUpperCase()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Modal d'ajout */}
      <dialog id="my_modal_5" className="modal bg-black bg-opacity-20">
        <div className="modal-box w-11/12 max-w-6xl text-black dark:text-white">
          <h3 className="font-bold text-lg mb-6">AJOUTER UN VÉHICULE</h3>
          {!isOnline && (
            <div className="alert alert-warning mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" /></svg>
              <span>MODE HORS LIGNE - LES DONNÉES SERONT ENVOYÉES PLUS TARD</span>
            </div>
          )}
          <form onSubmit={handleSubmit} className="py-4">
            {/* Première ligne - 3 colonnes */}
            <div className="grid grid-cols-3 gap-4 mb-4">
              <div>
                <label className="block text-sm font-medium mb-2">NOM</label>
                <input
                  type="text"
                  name="nom"
                  value={vehicule.nom}
                  onChange={handleChange}
                  className="input input-bordered w-full"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2">PRÉNOM</label>
                <input
                  type="text"
                  name="prenom"
                  value={vehicule.prenom}
                  onChange={handleChange}
                  className="input input-bordered w-full"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2">TÉLÉPHONE (8 chiffres)</label>
                <input
                  type="tel"
                  name="telephone"
                  value={vehicule.telephone}
                  onChange={handleChange}
                  className="input input-bordered w-full"
                  placeholder="12345678"
                  maxLength="8"
                  required
                />
              </div>
            </div>

            {/* Deuxième ligne - 3 colonnes */}
            <div className="grid grid-cols-3 gap-4 mb-4">
              <div>
                <label className="block text-sm font-medium mb-2">FRANCHISE</label>
                <input
                  type="text"
                  name="franchise"
                  value={vehicule.franchise}
                  onChange={handleChange}
                  className="input input-bordered w-full"
                  placeholder="AA-1234-NY (ex: NY, TA, DO, TI, AZ, MA, ZR, DI)"
                  required
                />
                <small className="text-gray-500">Format: AA-1234-XX où XX = code région Niger valide (NY, TA, DO, TI, AZ, MA, ZR, DI)</small>
              </div>
              <div>
                <label className="block text-sm font-medium mb-2">TYPE/COULEUR</label>
                <input
                  type="text"
                  name="couleur"
                  value={vehicule.couleur}
                  onChange={handleChange}
                  className="input input-bordered w-full"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2">CHÂSSIS</label>
                <input
                  type="text"
                  name="chassis"
                  value={vehicule.chassis}
                  onChange={handleChange}
                  className="input input-bordered w-full"
                  required
                />
              </div>
            </div>

            {/* Troisième ligne - 2 colonnes */}
            <div className="grid grid-cols-2 gap-4 mb-6">
              <div>
                <label className="block text-sm font-medium mb-2">NUMÉRO DE SÉRIE PLAQUE</label>
                <input
                  type="text"
                  name="numero_serie_plaque"
                  value={vehicule.numero_serie_plaque}
                  onChange={handleChange}
                  className="input input-bordered w-full"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2">USAGE</label>
                <input
                  type="text"
                  name="usage"
                  value={vehicule.usage}
                  onChange={handleChange}
                  className="input input-bordered w-full"
                  required
                />
              </div>
            </div>

            <div className="modal-action flex justify-between">
              <button type="button" className="btn" onClick={() => document.getElementById("my_modal_5").close()}>ANNULER</button>
              <button type="submit" className="btn btn-success">ENREGISTRER</button>
            </div>
          </form>
        </div>
      </dialog>

      {/* Modal de synchronisation */}
      <dialog id="syncModal" className="modal">
        <div className="modal-box text-black dark:text-white">
          <h3 className="font-bold text-lg">SYNCHRONISATION RÉUSSIE</h3>
          <p className="py-4">
            <span id="syncCount">0</span> VÉHICULE(S) EN ATTENTE ONT ÉTÉ SYNCHRONISÉS AVEC SUCCÈS.
          </p>
          <div className="modal-action">
            <button className="btn" onClick={() => document.getElementById("syncModal").close()}>
              FERMER
            </button>
          </div>
        </div>
      </dialog>

      {/* Toast Notification */}
      {toast.show && (
        <div className={`toast toast-top toast-end z-50`}>
          <div className={`alert ${
            toast.type === "success" ? "alert-success" : 
            toast.type === "error" ? "alert-error" : 
            "alert-info"
          }`}>
            <div>
              <span className="font-bold">
                {toast.type === "success" ? "✅" : 
                 toast.type === "error" ? "❌" : 
                 "ℹ️"}
              </span>
              <span>{toast.message}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
